"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M15.91 11H13.966C13.986 10.672 14 10.34 14 10C14 9.66 13.986 9.328 13.966 9H15.91C15.965 9.326 16 9.658 16 10C16 10.342 15.965 10.674 15.91 11ZM13.057 15.153C13.327 14.514 13.547 13.788 13.707 13H15.188C14.673 13.887 13.938 14.629 13.057 15.153ZM4.811 13H6.293C6.453 13.788 6.673 14.514 6.942 15.153C6.061 14.629 5.327 13.887 4.811 13ZM4.09 9H6.034C6.014 9.328 6 9.66 6 10C6 10.34 6.014 10.672 6.034 11H4.09C4.035 10.674 4 10.342 4 10C4 9.658 4.035 9.326 4.09 9ZM6.942 4.847C6.673 5.486 6.453 6.212 6.293 7H4.811C5.327 6.113 6.061 5.371 6.942 4.847ZM8.35 7C8.824 5.058 9.652 4 10 4C10.348 4 11.176 5.058 11.649 7H8.35ZM10 16C9.652 16 8.824 14.942 8.35 13H11.649C11.176 14.942 10.348 16 10 16ZM12 10C12 10.354 11.975 10.676 11.952 11H8.048C8.024 10.676 8 10.354 8 10C8 9.646 8.024 9.324 8.048 9H11.952C11.975 9.324 12 9.646 12 10ZM15.188 7H13.707C13.547 6.212 13.327 5.486 13.057 4.847C13.938 5.371 14.673 6.113 15.188 7ZM10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2Z",
    fill: "#727B7F"
  }));
};